import Lenis from "lenis";
import { registerGsap } from "./gsap";

/**
 * One shared Lenis instance (inertial smooth scroll) wired to GSAP's ticker and
 * ScrollTrigger. Ref-counted so any component can use it and the last one cleans up.
 */
let lenis: Lenis | null = null;
let refs = 0;
let tick: ((time: number) => void) | null = null;

export function acquireLenis(): Lenis {
  if (!lenis) {
    const { gsap, ScrollTrigger } = registerGsap();
    const instance = new Lenis({ lerp: 0.085, wheelMultiplier: 0.95, smoothWheel: true });
    instance.on("scroll", ScrollTrigger.update);
    tick = (time: number) => instance.raf(time * 1000);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);
    lenis = instance;
  }
  refs += 1;
  return lenis;
}

export function releaseLenis() {
  refs = Math.max(0, refs - 1);
  if (refs === 0 && lenis) {
    const { gsap } = registerGsap();
    if (tick) gsap.ticker.remove(tick);
    gsap.ticker.lagSmoothing(500, 33);
    lenis.destroy();
    lenis = null;
    tick = null;
  }
}

export const getLenis = () => lenis;

export const easeInOutCubic = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
